import { Flex } from 'foundations-components/components/Flex';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "AutosaveAlertsContainer__Container",
  componentId: "duq25q-0"
})(["position:fixed;bottom:", ";left:calc(var(--global-nav-vertical-nav-width) + 16px);z-index:1110;"], props => props.$isSavebarVisible ? '89px' : '16px');
const AutosaveAlertsContainer = ({
  children
}) => {
  // Check for the existence of the universal savebar so we can adjust indicator positioning.
  const universalSavebarEl = document.querySelector('[data-test-id="universal-save-bar-sticky-footer"]');
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(Container, {
      $isSavebarVisible: !!universalSavebarEl,
      children: /*#__PURE__*/_jsx(Flex, {
        gap: "200",
        children: children
      })
    })
  );
};
export default AutosaveAlertsContainer;